import Holidays from "date-holidays";
import dayjs from "dayjs";
import "dayjs/locale/pl";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useEffect, useState } from "react";
import { ChangeRepeating } from "views/StaffSchedule/StaffScheduleCreator/tools";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.locale("pl");

type Props = {
  dateStartFrom: Date;
  dateEnded?: Date | null;
  selectedChangeRepeating: ChangeRepeating;
};

export const useGetHolidaysInChangeRange = ({
  dateStartFrom,
  dateEnded,
  selectedChangeRepeating,
}: Props) => {
  const [holidaysInRange, setHolidaysInRange] = useState<string[]>([]);

  useEffect(() => {
    if (!dateEnded || selectedChangeRepeating === "DO_NOT_REPEAT") {
      setHolidaysInRange([]);
      return;
    }

    const from = dayjs(dateStartFrom);
    const to = dayjs(dateEnded);

    if (from.isAfter(to)) {
      setHolidaysInRange([]);
      return;
    }

    const hd = new Holidays("PL");
    const holidays = hd.getHolidays(from.year());

    const filtered = holidays.filter(({ date, type }) => {
      const holidayDate = dayjs(date);
      const isWeekday = holidayDate.day() !== 0 && holidayDate.day() !== 6;

      return (
        type === "public" &&
        holidayDate.isSameOrAfter(from, "day") &&
        holidayDate.isSameOrBefore(to, "day") &&
        isWeekday
      );
    });

    const formatted = filtered.map((h) => dayjs(h.date).format("D MMM"));

    setHolidaysInRange(formatted);
  }, [selectedChangeRepeating, dateStartFrom, dateEnded]);

  return holidaysInRange;
};
